import { Form, Select } from "antd";
import type React from "react";
import type { MemberAttribute } from "../../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../../providers/MemberAttributeContext";
import { FilterWrapper } from "../FilterWrapper";
import type { MemberAttributeFilterConfig } from "../types";

const { Option } = Select;

export const MultiSelectFilter: React.FC<{
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;
	const { attributeChoices } = memberAttribute;
	if (
		!memberAttribute.memberAttributeId ||
		!attributeChoices ||
		attributeChoices?.length === 0
	)
		return <></>;

	const formItem = (
		<Form.Item
			help={config.showHelpText ? memberAttribute.label : undefined}
			name={`memberAttributeFilter${memberAttribute.memberAttributeId}`}
			className="mb-4 w-full"
		>
			<Select
				showSearch={false}
				mode="multiple"
				placeholder="選択してください"
				allowClear
			>
				{attributeChoices.map((choice, index) => (
					<Option
						key={`${choice.attributeChoiceId}_${index}`}
						value={choice.contents}
					>
						{choice.contents}
					</Option>
				))}
			</Select>
		</Form.Item>
	);

	return (
		<FilterWrapper
			config={config}
			itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
		>
			{formItem}
		</FilterWrapper>
	);
};
